import React, {forwardRef, useImperativeHandle, useState} from "react";
import {Button, Input, Modal} from "antd";
import {useTranslation} from "react-i18next";
import {getImagePathWithTheme, imgPathPerfix, isNumber} from "@/utils";
import {IconCloseBlack} from "@/Icon";

const DialogPageSize = forwardRef(((props:{onDialogOkEvent:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))
    const {t} = useTranslation();
    const [isDialogShow,setIsDialogShow] = useState(false);
    const [width,setWidth] = useState('');
    const [height,setHeight] = useState('');

    const onShowDialog = (width,height)=>{
        setIsDialogShow(true);
        if (width != undefined && height != undefined){
            setWidth(width);
            setHeight(height);
        }
    }

    return(
        <Modal width={'468px'} styles={{height:'200px'}}
               centered={true} footer={''}
               closable={false} onCancel={(e)=>setIsDialogShow(false)} visible={isDialogShow}>
            <div style={{margin:'-6px -6px'}}>
                <div className='flex-row-vertical-center'>
                    <span className='font-family-medium font-size-14'>{t("Custom size")}</span>
                    <div style={{flexGrow:'1'}}></div>
                    <img className='img-mini-small-12 cursor-pointer' src={getImagePathWithTheme('close_black')} onClick={()=>{
                        setIsDialogShow(false);
                    }}/>
                </div>

                <div className='line' style={{margin:'16px -16px'}}></div>
                <table style={{marginTop:'4px',color:'var(--text-color)'}} >
                    <tr className='font-size-12'>
                        <td><span>{t("Width")}</span></td>
                        <td style={{width: '6px'}}></td>
                        <td><Input className='input-border' value={width} onChange={(e) => {
                            var value = (e.currentTarget.value) as string;
                            if (isNumber(value) || e.currentTarget.value == '') {
                                setWidth(e.currentTarget.value)
                            }
                        }}/></td>
                        <td style={{width: '26px'}}></td>
                        <td><span>{t("Height")}</span></td>
                        <td style={{width: '6px'}}></td>
                        <td>
                            <div className='flex-row-vertical-center'>
                                <Input className='input-border' value={height} onChange={(e) => {
                                    var value = (e.currentTarget.value) as string;
                                    if (isNumber(value) || e.currentTarget.value == '') {
                                        setHeight(e.currentTarget.value)
                                    }
                                }}/>
                                <span className='ml-8'>Px</span>
                            </div>

                        </td>
                    </tr>
                    {/*<tr>*/}
                    {/*    <td><Input className='input-border' value={width} onChange={(e) => {*/}
                    {/*        var value = (e.currentTarget.value) as string;*/}
                    {/*        if (isNumber(value) || e.currentTarget.value == '') {*/}
                    {/*            setWidth(e.currentTarget.value)*/}
                    {/*        }*/}
                    {/*    }}/></td>*/}
                    {/*    <td style={{width:'6px'}}></td>*/}
                    {/*    <td><Input className='input-border' value={height} onChange={(e)=>{*/}
                    {/*        var value = (e.currentTarget.value) as string;*/}
                    {/*        if (isNumber(value) || e.currentTarget.value == ''){*/}
                    {/*            setHeight(e.currentTarget.value)*/}
                    {/*        }*/}
                    {/*    }}/></td>*/}
                    {/*    <td style={{width:'20px'}}><span style={{marginLeft:'4px'}}>px</span></td>*/}
                    {/*</tr>*/}
                </table>
                <div style={{display:'flex',justifyContent:'center',alignItems:'center',marginTop:'32px'}}>
                    <Button style={{minWidth:'164px'}} className='button-border-gray-style font-family-medium' onClick={()=>setIsDialogShow(false)}>{t("Cancel")}</Button>
                    <Button className='button-solid-style font-family-medium'
                            type="primary"
                            onClick={()=>{
                                setIsDialogShow(false);
                                props.onDialogOkEvent(width,height);
                            }}
                            style={{marginLeft:'16px',minWidth:'164px'}}
                            htmlType={"submit"}>{t("Done")}</Button>
                </div>
            </div>

        </Modal>
    )

}))

export default React.memo(DialogPageSize);